// Login & SignUp
// TODO: Replace with reducerSlice
export const LOGIN_START = "LOGIN_START";
export const LOGIN_END_SUCCESS = "LOGIN_END_SUCCESS";
export const LOGIN_END_FAILED = "LOGIN_END_FAILED";
export const LOGGED_IN = "LOGGED_IN";
export const LOGGED_OUT = "LOGGED_OUT";
export const RESET_AUTH_ERROR = "RESET_AUTH_ERROR";
export const USER_ACTIVATED = "USER_ACTIVATED";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_FAILED = "RESET_PASSWORD_FAILED";

// Clients
export const CLIENTS_CLEAR_DATA = "CLIENTS_CLEAR_DATA";

export const CLIENTS_GET_REQUEST = "CLIENTS_GET_REQUEST";
export const CLIENTS_GET_REQUEST_FAILED = "CLIENTS_GET_REQUEST_FAILED";
export const CLIENTS_GET_REQUEST_SUCCESS = "CLIENTS_GET_REQUEST_SUCCESS";

export const CLIENT_ADD_REQUEST = "CLIENT_ADD_REQUEST";
export const CLIENT_ADD_REQUEST_FAILED = "CLIENT_ADD_REQUEST_FAILED";
export const CLIENT_ADD_REQUEST_SUCCESS = "CLIENT_ADD_REQUEST_SUCCESS";

export const CLIENT_EDIT_REQUEST = "CLIENT_EDIT_REQUEST";
export const CLIENT_EDIT_REQUEST_FAILED = "CLIENT_EDIT_REQUEST_FAILED";
export const CLIENT_EDIT_REQUEST_SUCCESS = "CLIENT_EDIT_REQUEST_SUCCESS";

export const CLIENT_REMOVE_REQUEST = "CLIENT_REMOVE_REQUEST";
export const CLIENT_REMOVE_REQUEST_FAILED = "CLIENT_REMOVE_REQUEST_FAILED";
export const CLIENT_REMOVE_REQUEST_SUCCESS = "CLIENT_REMOVE_REQUEST_SUCCESS";

export const CLIENT_UPGRADE_REQUEST = "CLIENT_UPGRADE_REQUEST";
export const CLIENT_UPGRADE_REQUEST_FAILED = "CLIENT_UPGRADE_REQUEST_FAILED";
export const CLIENT_UPGRADE_REQUEST_SUCCESS = "CLIENT_UPGRADE_REQUEST_SUCCESS";

export const CLIENT_SEARCH_REQUEST = "CLIENT_SEARCH_REQUEST";
export const CLIENT_SEARCH_REQUEST_FAILED = "CLIENT_SEARCH_REQUEST_FAILED";
export const CLIENT_SEARCH_REQUEST_SUCCESS = "CLIENT_SEARCH_REQUEST_SUCCESS";

export const VERTICALS_GET_REQUEST = "VERTICALS_GET_REQUEST";
export const VERTICALS_GET_REQUEST_FAILED = "VERTICALS_GET_REQUEST_FAILED";
export const VERTICALS_GET_REQUEST_SUCCESS = "VERTICALS_GET_REQUEST_SUCCESS";

// Notifications
export const NOTIFICATION_GET_REQUEST = "NOTIFICATION_GET_REQUEST";
export const NOTIFICATION_GET_REQUEST_FAILED =
  "NOTIFICATION_GET_REQUEST_FAILED";
export const NOTIFICATION_GET_REQUEST_SUCCESS =
  "NOTIFICATION_GET_REQUEST_SUCCESS";

export const NOTIFICATION_MARK_READED = "NOTIFICATION_MARK_READED";
export const NOTIFICATION_MARK_READED_FAILED =
  "NOTIFICATION_MARK_READED_FAILED";
export const NOTIFICATION_MARK_READED_SUCCESS =
  "NOTIFICATION_MARK_READED_SUCCESS";

// User Profile and related
export const USER_GET_REQUEST = "USER_GET_REQUEST";
export const USER_GET_REQUEST_FAILED = "USER_GET_REQUEST_FAILED";
export const USER_GET_REQUEST_SUCCESS = "USER_GET_REQUEST_SUCCESS";

export const COMPANY_PLAN_GET_REQUEST = "COMPANY_PLAN_GET_REQUEST";
export const COMPANY_PLAN_GET_REQUEST_FAILED =
  "COMPANY_PLAN_GET_REQUEST_FAILED";
export const COMPANY_PLAN_GET_REQUEST_SUCCESS =
  "COMPANY_PLAN_GET_REQUEST_SUCCESS";

export const PLANS_GET_REQUEST = "PLANS_GET_REQUEST";
export const PLANS_GET_REQUEST_FAILED = "PLANS_GET_REQUEST_FAILED";
export const PLANS_GET_REQUEST_SUCCESS = "PLANS_GET_REQUEST_SUCCESS";

export const SUBSCRIPTION_UPDATE_REQUEST = "SUBSCRIPTION_UPDATE_REQUEST";
export const SUBSCRIPTION_UPDATE_REQUEST_FAILED =
  "SUBSCRIPTION_UPDATE_REQUEST_FAILED";
export const SUBSCRIPTION_UPDATE_REQUEST_SUCCESS =
  "SUBSCRIPTION_UPDATE_REQUEST_SUCCESS";

export const PAYMENT_GET_CARDS = "PAYMENT_GET_CARDS";
export const PAYMENT_GET_CARDS_FAILED = "PAYMENT_GET_CARDS_FAILED";
export const PAYMENT_GET_CARDS_SUCCESS = "PAYMENT_GET_CARDS_SUCCESS";

export const PAYMENT_ADD_CARD = "PAYMENT_ADD_CARD";
export const PAYMENT_ADD_CARD_FAILED = "PAYMENT_ADD_CARD_FAILED";
export const PAYMENT_ADD_CARD_SUCCESS = "PAYMENT_ADD_CARD_SUCCESS";

export const PAYMENT_SELECT_CARD = "PAYMENT_SELECT_CARD";
export const PAYMENT_SELECT_CARD_FAILED = "PAYMENT_SELECT_CARD_FAILED";
export const PAYMENT_SELECT_CARD_SUCCESS = "PAYMENT_SELECT_CARD_SUCCESS";

export const PAYMENT_REMOVE_CARD = "PAYMENT_REMOVE_CARD";
export const PAYMENT_REMOVE_CARD_FAILED = "PAYMENT_REMOVE_CARD_FAILED";
export const PAYMENT_REMOVE_CARD_SUCCESS = "PAYMENT_REMOVE_CARD_SUCCESS";

export const PAYMENT_GET_HISTORY = "PAYMENT_GET_HISTORY";
export const PAYMENT_GET_HISTORY_FAILED = "PAYMENT_GET_HISTORY_FAILED";
export const PAYMENT_GET_HISTORY_SUCCESS = "PAYMENT_GET_HISTORY_SUCCESS";

export const PAYMENT_GET_STATISTICS = "PAYMENT_GET_STATISTICS";
export const PAYMENT_GET_STATISTICS_FAILED = "PAYMENT_GET_STATISTICS_FAILED";
export const PAYMENT_GET_STATISTICS_SUCCESS = "PAYMENT_GET_STATISTICS_SUCCESS";

export const PROFILES_GET_REQUEST = "PROFILES_GET_REQUEST";
export const PROFILES_GET_REQUEST_FAILED = "PROFILES_GET_REQUEST_FAILED";
export const PROFILES_GET_REQUEST_SUCCESS = "PROFILES_GET_REQUEST_SUCCESS";

export const PROFILE_REMOVE_REQUEST = "PROFILE_REMOVE_REQUEST";
export const PROFILE_REMOVE_REQUEST_FAILED = "PROFILE_REMOVE_REQUEST_FAILED";
export const PROFILE_REMOVE_REQUEST_SUCCESS = "PROFILE_REMOVE_REQUEST_SUCCESS";

export const PROFILE_EDIT_REQUEST = "PROFILE_EDIT_REQUEST";
export const PROFILE_EDIT_REQUEST_FAILED = "PROFILE_EDIT_REQUEST_FAILED";
export const PROFILE_EDIT_REQUEST_SUCCESS = "PROFILE_EDIT_REQUEST_SUCCESS";

// Audiences
export const AUDIENCES_GET_REQUEST = "AUDIENCES_GET_REQUEST";
export const AUDIENCES_GET_REQUEST_FAILED = "AUDIENCES_GET_REQUEST_FAILED";
export const AUDIENCES_GET_REQUEST_SUCCESS = "AUDIENCES_GET_REQUEST_SUCCESS";

export const AUDIENCE_ADD_REQUEST = "AUDIENCE_ADD_REQUEST";
export const AUDIENCE_ADD_REQUEST_FAILED = "AUDIENCE_ADD_REQUEST_FAILED";
export const AUDIENCE_ADD_REQUEST_SUCCESS = "AUDIENCE_ADD_REQUEST_SUCCESS";

export const AUDIENCE_EDIT_REQUEST = "AUDIENCE_EDIT_REQUEST";
export const AUDIENCE_EDIT_REQUEST_FAILED = "AUDIENCE_EDIT_REQUEST_FAILED";
export const AUDIENCE_EDIT_REQUEST_SUCCESS = "AUDIENCE_EDIT_REQUEST_SUCCESS";

export const AUDIENCE_REMOVE_REQUEST = "AUDIENCE_REMOVE_REQUEST";
export const AUDIENCE_REMOVE_REQUEST_FAILED = "AUDIENCE_REMOVE_REQUEST_FAILED";
export const AUDIENCE_REMOVE_REQUEST_SUCCESS =
  "AUDIENCE_REMOVE_REQUEST_SUCCESS";

export const AUDIENCE_SEARCH_REQUEST = "AUDIENCE_SEARCH_REQUEST";
export const AUDIENCE_SEARCH_REQUEST_FAILED = "AUDIENCE_SEARCH_REQUEST_FAILED";
export const AUDIENCE_SEARCH_REQUEST_SUCCESS =
  "AUDIENCE_SEARCH_REQUEST_SUCCESS";

export const AUDIENCE_GET_PRESETS = "AUDIENCE_GET_PRESETS";
export const AUDIENCE_GET_PRESETS_FAILED = "AUDIENCE_GET_PRESETS_FAILED";
export const AUDIENCE_GET_PRESETS_SUCCESS = "AUDIENCE_GET_PRESETS_SUCCESS";

export const AUDIENCE_GET_CATEGORIES = "AUDIENCE_GET_CATEGORIES";
export const AUDIENCE_GET_CATEGORIES_FAILED = "AUDIENCE_GET_CATEGORIES_FAILED";
export const AUDIENCE_GET_CATEGORIES_SUCCESS =
  "AUDIENCE_GET_CATEGORIES_SUCCESS";

export const AUDIENCE_GET_SUBCATEGORIES = "AUDIENCE_GET_SUBCATEGORIES";
export const AUDIENCE_GET_SUBCATEGORIES_FAILED =
  "AUDIENCE_GET_SUBCATEGORIES_FAILED";
export const AUDIENCE_GET_SUBCATEGORIES_SUCCESS =
  "AUDIENCE_GET_SUBCATEGORIES_SUCCESS";
export const AUDIENCE_SUBCATEGORIES_CLEAR = "AUDIENCE_SUBCATEGORIES_CLEAR";

export const AUDIENCE_GET_VARIABLES = "AUDIENCE_GET_VARIABLES";
export const AUDIENCE_GET_VARIABLES_FAILED = "AUDIENCE_GET_VARIABLES_FAILED";
export const AUDIENCE_GET_VARIABLES_SUCCESS = "AUDIENCE_GET_VARIABLES_SUCCESS";
export const AUDIENCE_VARIABLES_CLEAR = "AUDIENCE_VARIABLES_CLEAR";

export const AUDIENCE_GET_COUNTRIES = "AUDIENCE_GET_COUNTRIES";
export const AUDIENCE_GET_COUNTRIES_FAILED = "AUDIENCE_GET_COUNTRIES_FAILED";
export const AUDIENCE_GET_COUNTRIES_SUCCESS = "AUDIENCE_GET_COUNTRIES_SUCCESS";

export const AUDIENCE_GET_STATS = "AUDIENCE_GET_STATS";
export const AUDIENCE_GET_STATS_FAILED = "AUDIENCE_GET_STATS_FAILED";
export const AUDIENCE_GET_STATS_SUCCESS = "AUDIENCE_GET_STATS_SUCCESS";
export const AUDIENCE_CLEAR_STATS = "AUDIENCE_CLEAR_STATS";

export const GET_REGIONS = "GET_REGIONS";
export const GET_REGIONS_SUCCESS = "GET_REGIONS_SUCCESS";
export const GET_REGIONS_FAILED = "GET_REGIONS_FAILED";

export const ADD_REGIONS = "ADD_REGIONS";
export const ADD_REGIONS_SUCCESS = "ADD_REGIONS_SUCCESS";
export const ADD_REGIONS_FAILED = "ADD_REGIONS_FAILED";

export const DELETE_INFO_REGIONS = "DELETE_INFO_REGIONS";
export const DELETE_INFO_REGIONS_SUCCESS = "DELETE_INFO_REGIONS_SUCCESS";
export const DELETE_INFO_REGIONS_FAILED = "DELETE_INFO_REGIONS_FAILED";

export const DELETE_REGIONS = "DELETE_REGIONS";
export const DELETE_REGIONS_SUCCESS = "DELETE_REGIONS_SUCCESS";
export const DELETE_REGIONS_FAILED = "DELETE_REGIONS_FAILED";

export const GET_REGION_MAP = "GET_REGION_MAP";
export const GET_REGION_MAP_SUCCESS = "GET_REGION_MAP_SUCCESS";
export const GET_REGION_MAP_FAILED = "GET_REGION_MAP_FAILED";

export const AUDIENCE_GET_MAP = "AUDIENCE_GET_MAP";
export const AUDIENCE_GET_MAP_FAILED = "AUDIENCE_GET_MAP_FAILED";
export const AUDIENCE_GET_MAP_SUCCESS = "AUDIENCE_GET_MAP_SUCCESS";

export const AUDIENCE_GET_TAGS = "AUDIENCE_GET_TAGS";
export const AUDIENCE_GET_TAGS_FAILED = "AUDIENCE_GET_TAGS_FAILED";
export const AUDIENCE_GET_TAGS_SUCCESS = "AUDIENCE_GET_TAGS_SUCCESS";
export const AUDIENCE_CLEAR_TAGS = "AUDIENCE_CLEAR_TAGS";

export const AUDIENCE_GET_DESCRIPTON = "AUDIENCE_GET_DESCRIPTON";
export const AUDIENCE_GET_DESCRIPTON_FAILED = "AUDIENCE_GET_DESCRIPTON_FAILED";
export const AUDIENCE_GET_DESCRIPTON_SUCCESS =
  "AUDIENCE_GET_DESCRIPTON_SUCCESS";
export const AUDIENCE_CLEAR_DESCRIPTION = "AUDIENCE_CLEAR_DESCRIPTION";

export const AUDIENCE_GET_DEMOGRAPHICS = "AUDIENCE_GET_DEMOGRAPHICS";
export const AUDIENCE_GET_DEMOGRAPHICS_SUCCESS =
  "AUDIENCE_GET_DEMOGRAPHICS_SUCCESS";
export const AUDIENCE_GET_DEMOGRAPHICS_FAILED =
  "AUDIENCE_GET_DEMOGRAPHICS_FAILED";

// For limit & offset pagination
export const AUDIENCE_SET_AUDIENCES_OFFSET = "AUDIENCE_SET_AUDIENCES_OFFSET";
export const AUDIENCE_SET_PRESETS_OFFSET = "AUDIENCE_SET_PRESETS_OFFSET";

// For Backend search and filter
export const AUDIENCE_CLEAR_STATE_BEFORE_NEW_SEARCH =
  "AUDIENCE_CLEAR_STATE_BEFORE_NEW_SEARCH";

// For clear Audiences and Presets
export const AUDIENCE_PRESETS_CLEAR = "AUDIENCE_PRESETS_CLEAR";
export const AUDIENCE_AUDIENCES_CLEAR = "AUDIENCE_AUDIENCES_CLEAR";

// For SAM map
export const AUDIENCE_SAM_MAP_REQUEST = "AUDIENCE_SAM_MAP_REQUEST";
export const AUDIENCE_SAM_MAP_SUCCESS = "AUDIENCE_SAM_MAP_SUCCESS";
export const AUDIENCE_SAM_MAP_FAILED = "AUDIENCE_SAM_MAP_FAILED";
export const CLEAR_SAM_MAP_DATA = "CLEAR_SAM_MAP_DATA";

// For attach file
export const AUDIENCE_ATTACH_FILE_REQUEST = "AUDIENCE_ATTACH_FILE_REQUEST";
export const AUDIENCE_ATTACH_FILE_SUCCESS = "AUDIENCE_ATTACH_FILE_SUCCESS";
export const AUDIENCE_ATTACH_FILE_FAILED = "AUDIENCE_ATTACH_FILE_FAILED";

// Get audience by id
export const AUDIENCE_GET_AUDIENCE_BY_ID_REQUEST =
  "AUDIENCE_GET_AUDIENCE_BY_ID_REQUEST";
export const AUDIENCE_GET_AUDIENCE_BY_ID_SUCCESS =
  "AUDIENCE_GET_AUDIENCE_BY_ID_SUCCESS";
export const AUDIENCE_GET_AUDIENCE_BY_ID_FAILED =
  "AUDIENCE_GET_AUDIENCE_BY_ID_FAILED";

// CRM
// Companies
export const GET_COMPANIES = "GET_COMPANIES";
export const GET_COMPANIES_SUCCEED = "GET_COMPANIES_SUCCEED";
export const GET_COMPANIES_FAILED = "GET_COMPANIES_FAILED";

export const GET_COMPANY_DETAILS = "GET_COMPANY_DETAILS";
export const GET_COMPANY_DETAILS_FAILED = "GET_COMPANY_DETAILS_FAILED";
export const GET_COMPANY_DETAILS_SUCCEED = "GET_COMPANY_DETAILS_SUCCEED";

export const REMOVE_COMPANY_INFO = "REMOVE_COMPANY_INFO";

export const GET_COUNTRIES = "GET_COUNTRIES";
export const GET_COUNTRIES_SUCCEED = "GET_COUNTRIES_SUCCEED";
export const GET_COUNTRIES_FAILED = "GET_COUNTRIES_FAILED";

export const CRM_UPDATE_SELECTED_COMPANY = "CRM_UPDATE_SELECTED_COMPANY";
export const CRM_UPDATE_SELECTED_COMPANY_SUCCEED =
  "CRM_UPDATE_SELECTED_COMPANY_SUCCEED";
export const CRM_UPDATE_SELECTED_COMPANY_FAILED =
  "CRM_UPDATE_SELECTED_COMPANY_FAILED";

export const RESET_ERRORS_AUDIENCE_ACTIVITY = "GET_AUDIENCE_ACTIVITY";
export const GET_AUDIENCE_ACTIVITY = "GET_AUDIENCE_ACTIVITY";
export const GET_AUDIENCE_ACTIVITY_SUCCEED = "GET_AUDIENCE_ACTIVITY_SUCCEED";
export const GET_AUDIENCE_ACTIVITY_FAILED = "GET_AUDIENCE_ACTIVITY_FAILED";

export const CREATE_PAYMENT_INFO = "CREATE_PAMENT_INFO";
export const CREATE_PAYMENT_INFO_SUCCEED = "CREATE_PAMENT_INFO_SUCCEED";
export const CREATE_PAYMENT_INFO_FAILED = "CREATE_PAMENT_INFO_FAILED";

export const GET_CRM_CATEGORIES = "GET_CRM_CATEGORIES";
export const GET_CRM_CATEGORIES_SUCCEED = "GET_CRM_CATEGORIES_SUCCEED";
export const GET_CRM_CATEGORIES_FAILED = "GET_CRM_CATEGORIES_FAILED";

export const GET_CRM_COUNTRY_DATASET = "GET_CRM_COUNTRY_DATASET";
export const GET_CRM_COUNTRY_DATASET_SUCCEED =
  "GET_CRM_COUNTRY_DATASET_SUCCEED";
export const GET_CRM_COUNTRY_DATASET_FAILED = "GET_CRM_COUNTRY_DATASET_FAILED";

export const CREATE_SUBSCRIPTION = "CREATE_SUBSCRIPTION";
export const CREATE_SUBSCRIPTION_SUCCEED = "CREATE_SUBSCRIPTION_SUCCEED";
export const CREATE_SUBSCRIPTION_FAILED = "CREATE_SUBSCRIPTION_FAILED";

export const CRM_INVITE_USER = "CRM_INVITE_USER";
export const CRM_INVITE_USER_SUCCEED = "CRM_INVITE_USER_SUCCEED";
export const CRM_INVITE_USER_FAILED = "CRM_INVITE_USER_FAILED";
export const CRM_REMOVE_USER = "CRM_REMOVE_USER";

export const CRM_GET_STAFF = "CRM_GET_STAFF";
export const CRM_GET_STAFF_SUCCEED = "CRM_GET_STAFF_SUCCEED";
export const CRM_GET_STAFF_FAILED = "CRM_GET_STAFF_FAILED";

export const CRM_REMOVE_COMPANY = "CRM_REMOVE_COMPANY";
export const CRM_REMOVE_COMPANY_SUCCEED = "CRM_REMOVE_COMPANY_SUCCEED";
export const CRM_REMOVE_COMPANY_FAILED = "CRM_REMOVE_COMPANY_FAILED";
